import { render, staticRenderFns } from "./ProductDisplayCategoryBatchPopupIframe.vue?vue&type=template&id=cb15f3d0&"
import script from "./ProductDisplayCategoryBatchPopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductDisplayCategoryBatchPopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports